import React from 'react';
import PropTypes from 'prop-types';

import InlineSVG from 'svg-inline-react';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';

import classes from './FileList.scss';

import icDelete from '../../assets/ic_delete.svg';
import { dateFormatLong } from '../../helpers/formats';
import SplitButton from '../SplitButton/SplitButton';
import numeral from 'numeral';
import FileIcon from '../FileIcon/FileIcon';

class FileList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: 'cards',
    };
  }
  renderDate = date => {
    const parsed = moment(date);
    const isPast = moment()
      .subtract(1, 'months')
      .diff(parsed);

    if (isPast > 0) {
      return (
        <div className={classes.dateContainer}>
          <span>{moment(date).format(dateFormatLong)}</span>
        </div>
      );
    }

    return (
      <div className={classes.dateContainer}>
        <span className={classes.normal}>{moment(date).fromNow()}</span>
        <span className={classes.technical}>
          {moment(date).format(dateFormatLong)}
        </span>
      </div>
    );
  };

  renderFiles = () => {
    const filesDom = [];

    this.props.files.forEach(data => {
      if (typeof data.deleted_at === 'undefined' || data.deleted_at === null) {
        if (this.state.mode === 'cards') {
          let background = null;
          if (
            data.extension === 'jpeg' ||
            data.extension === 'jpg' ||
            data.extension === 'png' ||
            data.extension === 'gif'
          ) {
            const path = __DEV__ ? data.download : data.thumbnail;

            background = (
              <div
                className={classes.cardBackground}
                style={{ backgroundImage: `url(${path}?w=200&h=200&fit=crop)` }}
              />
            );
          }

          filesDom.push(
            <div
              className={`col-xs-6 col-sm-4 ${classes.fileCardContainer}`}
              key={`fileList_${data.id}`}
            >
              <div className={classes.fileCard}>
                <div className={classes.cardIcon}>
                  <FileIcon extension={data.extension} big />
                </div>
                <a
                  href={data.download}
                  target="_blank"
                  className={classes.cardTitle}
                >
                  {data.filename_download}
                </a>
                <span className={classes.cardSize}>
                  {numeral(data.filesize).format('0.0b')}
                </span>
                <InlineSVG
                  className={classes.cardDelete}
                  src={icDelete}
                  data-tip={`${data.filename_download} entfernen`}
                  onClick={() => {
                    this.props.onDelete(data.id);
                  }}
                />
                {background}
              </div>
            </div>,
          );
        } else {
          filesDom.push(
            <div
              className={`col-xs-12 ${classes.file}`}
              key={`file_${data.id}`}
            >
              <div className="row">
                <span className="col-xs-1 text-center flex-vcenter">
                  <FileIcon extension={data.extension} />
                </span>
                <span className={`col-xs-10 ${classes.noteContent}`}>
                  <a href={data.download} target="_blank">
                    {data.filename_download}
                  </a>
                  <div className={classes.meta}>
                    {numeral(data.filesize).format('0.0b')} · &nbsp;
                    {this.renderDate(data.created_at)}
                  </div>
                </span>
                <span
                  className={`col-xs-1 text-right delete ${classes.delete}`}
                >
                  <InlineSVG
                    src={icDelete}
                    data-tip={`${data.filename_download} entfernen`}
                    onClick={() => {
                      this.props.onDelete(data.id);
                    }}
                  />
                </span>
              </div>
            </div>,
          );
        }
      }
    });

    return <div className="row">{filesDom}</div>;
  };

  render() {
    return (
      <div className={classes.files}>
        <div className="row">
          <div className="col-xs-4 col-md-3 flex-vcenter">
            <h3>Dateien</h3>
          </div>
          <div className="col-xs-8 col-md-9 flex-vcenter text-right">
            <div>
              <SplitButton
                selected={this.state.mode}
                onSelect={mode => this.setState({ mode })}
                buttons={[
                  {
                    title: 'Liste',
                    value: 'list',
                  },
                  {
                    title: 'Karten',
                    value: 'cards',
                  },
                ]}
              />
            </div>
          </div>
        </div>

        {this.renderFiles()}

        <ReactTooltip
          className={classes.tooltip}
          place="left"
          type="dark"
          effect="solid"
          html
        />
      </div>
    );
  }
}
FileList.propTypes = {
  files: PropTypes.array.isRequired,
  onDelete: PropTypes.func,
};
export default FileList;



// WEBPACK FOOTER //
// ./src/components/FileList/FileList.js